<template>
  <el-dialog
    title="抖音账号"
    :visible.sync="modelValue"
    width="664px"
    height="440px"
    custom-class="_auths_popup"
    :before-close="handleClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="auths" v-show="dataArr.length">
      <useTable
        :httprequest="httprequest"
        ref="useTable"
        :headerList="headerData"
        :onEvents="onEvents"
        tableRef="tableRefFun"
      ></useTable>
    </div>
    <div :class="dataArr.length ? 'footer_dialogs' : 'footer_dialogs_none'">
      <el-button v-if="dataArr.length" type="primary" @click="submitDyCode"
        >确 定</el-button
      >
      <el-button v-else type="primary" @click="addDyCode"
        >去添加抖音账号</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import api from "@/api/common/help";
import useTable from "@/components/useTable/useTable.vue";
import { cloneDeep } from "lodash-unified";
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    selectIds: {
      type: Array,
      default: () => [],
    },
    selectInfo: {
      type: Array,
      default: () => [],
    },
  },

  components: {
    useTable,
  },
  data() {
    return {
      headerData: [
        {
          props: {
            label: "",
            type: "selection",
            width: 80,
          },
        },
        {
          props: {
            label: "序号",
            type: "index",
            width: 100,
          },
          render: (h, scope) => {
            return <span>{scope.$index + 1}</span>;
          },
        },
        {
          props: {
            label: "抖音号",
            "show-overflow-tooltip": true,
          },
          render: (h, scope) => {
            return (
              <div class="dy_warp">
                <img src={scope.row.avatar} class="avatar" />
                <span class="nickName">{scope.row.nickname}</span>
              </div>
            );
          },
        },
        {
          props: {
            prop: "update_time",
            label: "授权时间",
            width: 180,
          },
        },
      ],
      dataArr: [],
    };
  },
  computed: {
    modelValue: {
      get() {
        return cloneDeep(this.value);
      },
      set(news) {
        this.$emit("input", news);
      },
    },
    select_ids: {
      get() {
        return cloneDeep(this.selectIds);
      },
      set(news) {},
    },
    selectInfos: {
      get() {
        return cloneDeep(this.selectInfo);
      },
      set(news) {},
    },
    onEvents() {
      return {
        "selection-change": (e) => {
          e.forEach((item) => {
            let index = this.select_ids.findIndex((ite) => {
              return ite == item.id;
            });
            if (index == -1) {
              this.select_ids.push(item.id);
              this.selectInfos.push(item)
            }
          });
        },
      };
    },
    // tableRefFun(value) {
    //     console.log(value,'value-=-=')
    //   this.tableRef = value;
    // },
  },
  methods: {
    async httprequest(params) {
      let _this = this;
      let res = await api.codeList.requestFun({}, "post", { "come-from": 1 });
      let data = [...res.available, ...res.overtime];
      this.dataArr = data;
      _this.select_ids.forEach((item) => {
        data.forEach((val) => {
          if (val.id == item) {
            console.log(_this.tableRef, val, "useTableRun.value.");
            setTimeout(() => {
              _this.$refs.useTable.$children[0].toggleRowSelection(val, true);
            }, 0);
          }
        });
      });
      let keys = {
        data: data,
        total: data.length,
      };
      return keys;
    },
    submitDyCode() {
      this.modelValue = false;
      this.$emit("update:selectIds", this.select_ids);
      this.$emit("update:selectInfo", this.selectInfos);
    },
    handleClose() {
      this.modelValue = false;
    },
    addDyCode() {
      this.$router.push({
        path: this.staticPath + "dyAccountIndex",
      });
    },
  },
};
</script>

<style lang="less">
.auths {
  text-align: center;
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 0;
    height: 10px;
  }
}
.dy_warp {
  display: flex;
}
.avatar {
  width: 25px;
  height: 25px;
  margin-right: 10px;
  border-radius: 50%;
  display: block;
  flex-shrink: 0;
}
.nickName{
  flex: 1;
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.footer_dialogs {
  width: 100%;
  margin-top: 40px;
  display: flex;

  justify-content: center;
}
.footer_dialogs_none {
  width: 100%;
  display: flex;

  justify-content: center;
}

</style>